export default {};


// WEBPACK FOOTER //
// ./src/modules/undesirableBehavior/vuex/getters.js